var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.expressCheckoutAvailable)?_c('div',{staticClass:"apple-pay"},[_c('ApplePayButton',{class:_vm.buttonClasses,attrs:{"onClick":_vm.startApplePayExpressCheckout,"isLoading":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }